import { cn } from '@tempo-io/sui-class-utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@tempo-io/sui-tooltip';
import type { ReactNode } from 'react';

interface TooltipIconButtonProps {
  icon: ReactNode;
  tooltipText: string;
  onClick?: () => void;
  className?: string;
  side?: 'left' | 'right' | 'top' | 'bottom';
  disabled?: boolean;
  testId?: string;
}

export const TooltipIconButton = ({
  icon,
  tooltipText,
  onClick,
  className,
  side = 'left',
  disabled = false,
  testId,
}: TooltipIconButtonProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <button
        data-testid={testId}
        type="button"
        className={cn(
          'inline-flex p-2',
          disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
          className,
        )}
        onClick={disabled ? undefined : onClick}
        aria-label={tooltipText}
        aria-disabled={disabled}
        disabled={disabled}
      >
        {icon}
      </button>
    </TooltipTrigger>
    <TooltipContent side={side}>
      <p>{tooltipText}</p>
    </TooltipContent>
  </Tooltip>
);
